// extracted by mini-css-extract-plugin
export var brandButton = "ecomm-showcase-module--brandButton--b3c21";
export var brandLogo = "ecomm-showcase-module--brandLogo--b7556";
export var brands = "ecomm-showcase-module--brands--0ae28";
export var screenshotContainer = "ecomm-showcase-module--screenshotContainer--d3a7f";
export var screenshotImage = "ecomm-showcase-module--screenshotImage--3e9f1";
export var screenshotWrapper = "ecomm-showcase-module--screenshotWrapper--25be9";
export var screenshots = "ecomm-showcase-module--screenshots--0cb06";
export var storeLink = "ecomm-showcase-module--storeLink--3d7af";